import { render, staticRenderFns } from "./MonitTable.vue?vue&type=template&id=2e7d8fcb&"
import script from "./MonitTable.vue?vue&type=script&lang=js&"
export * from "./MonitTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports